// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ClientResultsRouteImport } from './routes/client-results'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FinancialBlindSpotFinderRouteImport } from './routes/financial-blind-spot-finder'
import { Route as FrequentlyAskedQuestionsRouteImport } from './routes/frequently-asked-questions'
import { Route as HowWeWorkRouteImport } from './routes/how-we-work'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as StrategicFinanceReviewRouteImport } from './routes/strategic-finance-review'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as IndustriesAutomotiveRouteImport } from './routes/industries.automotive'
import { Route as IndustriesConstructionTradesRouteImport } from './routes/industries.construction-trades'
import { Route as IndustriesHealthDentalRouteImport } from './routes/industries.health-dental'
import { Route as IndustriesProfessionalServicesRouteImport } from './routes/industries.professional-services'
import { Route as IndustriesPropertyRouteImport } from './routes/industries.property'
import { Route as IndustriesServiceBusinessesRouteImport } from './routes/industries.service-businesses'
import { Route as InsightsIndexRouteImport } from './routes/insights.index'
import { Route as InsightsSlugRouteImport } from './routes/insights.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAccountsManagementRouteImport } from './routes/services.accounts-management'
import { Route as ServicesManagementReportingRouteImport } from './routes/services.management-reporting'
import { Route as ServicesPayrollRouteImport } from './routes/services.payroll'
import { Route as ServicesStrategicBookkeepingRouteImport } from './routes/services.strategic-bookkeeping'
import { Route as ServicesXeroRouteImport } from './routes/services.xero'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ClientResultsRoute = ClientResultsRouteImport.update({
            id: '/client-results',path: '/client-results',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FinancialBlindSpotFinderRoute = FinancialBlindSpotFinderRouteImport.update({
            id: '/financial-blind-spot-finder',path: '/financial-blind-spot-finder',getParentRoute: () => rootRouteImport
          })
const FrequentlyAskedQuestionsRoute = FrequentlyAskedQuestionsRouteImport.update({
            id: '/frequently-asked-questions',path: '/frequently-asked-questions',getParentRoute: () => rootRouteImport
          })
const HowWeWorkRoute = HowWeWorkRouteImport.update({
            id: '/how-we-work',path: '/how-we-work',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const InsightsRoute = InsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => rootRouteImport
          })
const PackagesRoute = PackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const StrategicFinanceReviewRoute = StrategicFinanceReviewRouteImport.update({
            id: '/strategic-finance-review',path: '/strategic-finance-review',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndustriesRoute
          })
const IndustriesAutomotiveRoute = IndustriesAutomotiveRouteImport.update({
            id: '/automotive',path: '/automotive',getParentRoute: () => IndustriesRoute
          })
const IndustriesConstructionTradesRoute = IndustriesConstructionTradesRouteImport.update({
            id: '/construction-trades',path: '/construction-trades',getParentRoute: () => IndustriesRoute
          })
const IndustriesHealthDentalRoute = IndustriesHealthDentalRouteImport.update({
            id: '/health-dental',path: '/health-dental',getParentRoute: () => IndustriesRoute
          })
const IndustriesProfessionalServicesRoute = IndustriesProfessionalServicesRouteImport.update({
            id: '/professional-services',path: '/professional-services',getParentRoute: () => IndustriesRoute
          })
const IndustriesPropertyRoute = IndustriesPropertyRouteImport.update({
            id: '/property',path: '/property',getParentRoute: () => IndustriesRoute
          })
const IndustriesServiceBusinessesRoute = IndustriesServiceBusinessesRouteImport.update({
            id: '/service-businesses',path: '/service-businesses',getParentRoute: () => IndustriesRoute
          })
const InsightsIndexRoute = InsightsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => InsightsRoute
          })
const InsightsSlugRoute = InsightsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => InsightsRoute
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesAccountsManagementRoute = ServicesAccountsManagementRouteImport.update({
            id: '/accounts-management',path: '/accounts-management',getParentRoute: () => ServicesRoute
          })
const ServicesManagementReportingRoute = ServicesManagementReportingRouteImport.update({
            id: '/management-reporting',path: '/management-reporting',getParentRoute: () => ServicesRoute
          })
const ServicesPayrollRoute = ServicesPayrollRouteImport.update({
            id: '/payroll',path: '/payroll',getParentRoute: () => ServicesRoute
          })
const ServicesStrategicBookkeepingRoute = ServicesStrategicBookkeepingRouteImport.update({
            id: '/strategic-bookkeeping',path: '/strategic-bookkeeping',getParentRoute: () => ServicesRoute
          })
const ServicesXeroRoute = ServicesXeroRouteImport.update({
            id: '/xero',path: '/xero',getParentRoute: () => ServicesRoute
          })





const IndustriesRouteChildren = {
  IndustriesAutomotiveRoute: IndustriesAutomotiveRoute,IndustriesConstructionTradesRoute: IndustriesConstructionTradesRoute,IndustriesHealthDentalRoute: IndustriesHealthDentalRoute,IndustriesProfessionalServicesRoute: IndustriesProfessionalServicesRoute,IndustriesPropertyRoute: IndustriesPropertyRoute,IndustriesServiceBusinessesRoute: IndustriesServiceBusinessesRoute,IndustriesIndexRoute: IndustriesIndexRoute
}

const IndustriesRouteWithChildren = IndustriesRoute._addFileChildren(IndustriesRouteChildren)




const InsightsRouteChildren = {
  InsightsSlugRoute: InsightsSlugRoute,InsightsIndexRoute: InsightsIndexRoute
}

const InsightsRouteWithChildren = InsightsRoute._addFileChildren(InsightsRouteChildren)




const ServicesRouteChildren = {
  ServicesAccountsManagementRoute: ServicesAccountsManagementRoute,ServicesManagementReportingRoute: ServicesManagementReportingRoute,ServicesPayrollRoute: ServicesPayrollRoute,ServicesStrategicBookkeepingRoute: ServicesStrategicBookkeepingRoute,ServicesXeroRoute: ServicesXeroRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ClientResultsRoute: ClientResultsRoute,ContactRoute: ContactRoute,FinancialBlindSpotFinderRoute: FinancialBlindSpotFinderRoute,FrequentlyAskedQuestionsRoute: FrequentlyAskedQuestionsRoute,HowWeWorkRoute: HowWeWorkRoute,IndustriesRoute: IndustriesRouteWithChildren,InsightsRoute: InsightsRouteWithChildren,PackagesRoute: PackagesRoute,PrivacyRoute: PrivacyRoute,ServicesRoute: ServicesRouteWithChildren,StrategicFinanceReviewRoute: StrategicFinanceReviewRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)